import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();
  const path = location.pathname;

  const labelMap = {
    "/": "Home",
    "/education": "Education",
    "/experience": "Experience",
    "/projects": "Projects",
    "/skills": "Skills",
    "/resume": "Resume",
    "/references": "References",
    "/achievements": "Achievements",
    "/certificates": "Certificates",
    "/feedback": "Feedback",
    "/referencebtech": "B.Tech",
    "/referencehs": "Higher Secondary",
    "/referencesec": "Secondary",
    "/viewResume": "View Resume",
    "/test": "Test",
  };

  const current = labelMap[path] || "Home";

  return (
    <nav aria-label="Breadcrumb" className="px-5 sm:px-20 mt-2">
      <ol className="flex items-center text-sm text-slate-700 dark:text-slate-300 space-x-2">
        <li>
          <Link to="/" className="hover:underline">Home</Link>
        </li>
        {path !== "/" && (
          <>
            <li aria-hidden="true">/</li>
            <li>
              <span className="font-semibold" aria-current="page">
                {current}
              </span>
            </li>
          </>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;